/**
 * Gestisce la visibilità del banner cookie Iubenda
 * Nasconde il banner dopo che l'utente ha dato il consenso
 */

/**
 * Nasconde il banner Iubenda quando il consenso è stato dato
 */
function hideIubendaBannerIfConsentGiven() {
  // Funzione per verificare se il consenso è stato dato
  const hasConsentGiven = () => {
    try {
      // Controlla i cookie di consenso Iubenda
      // Iubenda usa cookie specifici per il consenso
      const cookies = document.cookie.split('; ');
      
      // Cerca cookie Iubenda specifici per il consenso
      // I cookie Iubenda hanno pattern come: _iub_cs-{id}={timestamp}
      // O: iub_cs-{id}={value}
      const consentCookie = cookies.find(row => {
        const trimmed = row.trim();
        return trimmed.startsWith('_iub_cs-') || 
               trimmed.startsWith('iub_cs-') ||
               (trimmed.includes('iubenda') && trimmed.includes('consent') && trimmed.includes('='));
      });
      
      if (consentCookie) {
        // Estrai il valore del cookie
        const cookieValue = consentCookie.split('=').slice(1).join('='); // Gestisce valori con '='
        
        // Il consenso è dato se:
        // 1. Il valore contiene esplicitamente "true"
        // 2. Il valore è un numero/timestamp (lunghezza > 10 indica un timestamp)
        // 3. Il valore è "1" (consenso esplicito)
        if (cookieValue) {
          const lowerValue = cookieValue.toLowerCase();
          if (lowerValue === 'true' || lowerValue === '1' || cookieValue.length > 10) {
            // Verifica che non sia solo un cookie di sessione vuoto
            if (cookieValue !== 'false' && cookieValue !== '0' && cookieValue !== '') {
              return true;
            }
          }
        }
      }
      
      // Controlla anche localStorage (alcune versioni di Iubenda lo usano)
      if (window.localStorage) {
        for (let i = 0; i < window.localStorage.length; i++) {
          const key = window.localStorage.key(i);
          if (key && (key.includes('iubenda') || key.includes('consent'))) {
            const value = window.localStorage.getItem(key);
            if (value) {
              const lowerValue = value.toLowerCase();
              // Solo se il valore indica esplicitamente consenso dato
              if (lowerValue === 'true' || lowerValue === '1') {
                return true;
              }
            }
          }
        }
      }
    } catch (e) {
      console.debug('Iubenda banner manager: errore nel controllo consenso', e);
    }
    // Se non troviamo evidenza di consenso, restituiamo false
    // Questo permette al banner di essere visibile
    return false;
  };

  // Funzione per nascondere il banner e la barra bianca persistente
  const hideBanner = () => {
    // IMPORTANTE: Questa funzione viene chiamata SOLO quando il consenso è stato dato
    // IMPORTANTE: NON nascondere MAI il popup di consenso iniziale o il popup delle preferenze
    
    // Controlla se c'è un popup/modal aperto (preferenze o consenso iniziale)
    const isPopupOpen = document.querySelector('.iubenda-cs-overlay, .iubenda-cs-modal, .iubenda-cs-popup');
    if (isPopupOpen) {
      return; // Non nascondere nulla se c'è un popup aperto
    }

    // IMPORTANTE: NON nascondere MAI il popup di consenso iniziale
    // Il popup di consenso iniziale ha solitamente pulsanti "Accetta" o "Rifiuta"
    const allIubendaElements = document.querySelectorAll('[class*="iubenda"], [id*="iubenda"]');
    for (const element of allIubendaElements) {
      const buttons = element.querySelectorAll('button');
      for (const button of buttons) {
        const buttonText = (button.textContent || '').toLowerCase();
        if (buttonText.includes('accetta') || buttonText.includes('accept') || 
            buttonText.includes('rifiuta') || buttonText.includes('reject') ||
            button.classList.toString().toLowerCase().includes('accept') ||
            button.classList.toString().toLowerCase().includes('reject')) {
          return; // Non nascondere il popup di consenso iniziale
        }
      }
    }

    // Selettori per il banner Iubenda e la barra bianca persistente (escludiamo l'icona persistente)
    const bannerSelectors = [
      '.iubenda-cs-banner:not(.iubenda-cs-preferences-link):not(.iubenda-cs-close-btn):not(.iubenda-cs-overlay):not(.iubenda-cs-modal)',
      '[id*="iubenda-cs-banner"]:not([id*="preferences"]):not([id*="close"]):not([id*="overlay"]):not([id*="modal"])',
      '[class*="iubenda-cs-banner"]:not([class*="preferences"]):not([class*="close"]):not([class*="overlay"]):not([class*="modal"])',
      '.iubenda-cs-consent:not(.iubenda-cs-preferences-link):not(.iubenda-cs-close-btn):not(.iubenda-cs-overlay):not(.iubenda-cs-modal)',
      '[id*="iubenda-cs-consent"]:not([id*="preferences"]):not([id*="close"]):not([id*="overlay"]):not([id*="modal"])',
      // Selettori per la barra bianca persistente in fondo pagina
      '[class*="iubenda"][class*="consent"]:not([class*="preferences"]):not([class*="close"]):not([class*="link"]):not([class*="overlay"]):not([class*="modal"])',
      '[id*="iubenda"][id*="consent"]:not([id*="preferences"]):not([id*="close"]):not([id*="overlay"]):not([id*="modal"])',
      // Qualsiasi elemento Iubenda posizionato in fondo (fixed o absolute bottom)
      '[class*="iubenda-cs"]:not([class*="preferences"]):not([class*="close"]):not([class*="link"]):not([class*="overlay"]):not([class*="modal"])'
    ];

    bannerSelectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          // IMPORTANTE: Escludi SEMPRE il popup di consenso iniziale (quello con i pulsanti Accetta/Rifiuta)
          const buttons = element.querySelectorAll('button');
          let hasConsentButtons = false;
          for (const button of buttons) {
            const buttonText = (button.textContent || '').toLowerCase();
            const buttonClasses = button.classList.toString().toLowerCase();
            if (buttonText.includes('accetta') || buttonText.includes('accept') || 
                buttonText.includes('rifiuta') || buttonText.includes('reject') ||
                buttonClasses.includes('accept') || buttonClasses.includes('reject')) {
              hasConsentButtons = true;
              break;
            }
          }
          if (hasConsentButtons) {
            return; // NON nascondere MAI il popup di consenso iniziale
          }

          // Escludi elementi che sono l'icona persistente (solo quella piccola icona)
          if (element.classList.contains('iubenda-cs-preferences-link') ||
              element.classList.contains('iubenda-cs-close-btn') ||
              (element.id && (element.id.includes('preferences') || element.id.includes('close')))) {
            // Controlla se è solo l'icona piccola (non la barra bianca)
            const style = window.getComputedStyle(element);
            const isSmallIcon = element.offsetWidth < 50 && element.offsetHeight < 50;
            if (isSmallIcon) {
              return; // Non nascondere l'icona persistente piccola
            }
          }

          // Controlla se il banner è minimizzato o se ha l'attributo di consenso dato
          const isMinimized = element.classList.contains('iubenda-cs-banner-minimized');
          const hasConsentGivenAttr = element.getAttribute('data-iubenda-consent-given') === 'true';
          
          // Controlla se è la barra bianca persistente (elemento con testo "Informativa sulla raccolta" o "preferenze privacy")
          // MA NON il popup di consenso iniziale
          const elementText = element.textContent || '';
          const isPrivacyBar = (elementText.includes('Informativa sulla raccolta') || 
                              elementText.includes('preferenze relative alla privacy') ||
                              elementText.includes('preferenze privacy')) &&
                              !elementText.includes('Accetta') && 
                              !elementText.includes('Rifiuta') &&
                              !elementText.includes('Accept') &&
                              !elementText.includes('Reject');
          
          // Nascondi il banner/barra se:
          // 1. È minimizzato
          // 2. Ha l'attributo di consenso dato
          // 3. È la barra bianca persistente (questa funzione viene chiamata solo se consenso dato)
          // MA NON se è il popup di consenso iniziale
          if (isMinimized || hasConsentGivenAttr || isPrivacyBar) {
            element.style.display = 'none';
            element.style.visibility = 'hidden';
            element.style.opacity = '0';
            element.style.height = '0';
            element.style.maxHeight = '0';
            element.style.overflow = 'hidden';
            element.style.margin = '0';
            element.style.padding = '0';
            element.style.border = 'none';
            // Aggiungi una classe per identificare che è stato nascosto
            element.classList.add('iubenda-banner-hidden');
          }
        });
      } catch (e) {
        console.debug('Iubenda banner manager: errore nel nascondere banner', e);
      }
    });

    // Cerca e nasconde anche la barra bianca persistente con un approccio più diretto
    // Cerca tutti gli elementi Iubenda che potrebbero essere la barra bianca
    // E anche elementi bianchi in fondo alla pagina che potrebbero essere la barra
    try {
      // Prima cerca elementi Iubenda
      const allIubendaElements = document.querySelectorAll('[class*="iubenda"], [id*="iubenda"]');
      allIubendaElements.forEach(element => {
        // IMPORTANTE: Escludi SEMPRE l'icona persistente piccola (quella con la chiave/lucchetto)
        // L'icona deve rimanere sempre visibile e funzionante
        const isSmallIcon = element.offsetWidth < 60 && element.offsetHeight < 60;
        if (isSmallIcon && (
          element.classList.contains('iubenda-cs-preferences-link') ||
          element.classList.contains('iubenda-cs-close-btn') ||
          element.id && (element.id.includes('preferences') || element.id.includes('close'))
        )) {
          return; // NON nascondere mai l'icona persistente piccola
        }

        // IMPORTANTE: Escludi SEMPRE il popup/modal che si apre quando clicchi sull'icona
        // Il popup ha solitamente classi come "iubenda-cs-overlay" o "iubenda-cs-modal"
        if (element.classList.contains('iubenda-cs-overlay') ||
            element.classList.contains('iubenda-cs-modal') ||
            element.classList.contains('iubenda-cs-popup') ||
            element.id && (element.id.includes('overlay') || element.id.includes('modal') || element.id.includes('popup'))) {
          return; // NON nascondere mai il popup delle preferenze
        }

        // IMPORTANTE: NON nascondere MAI il popup di consenso iniziale (quello con i pulsanti Accetta/Rifiuta)
        const buttons = element.querySelectorAll('button');
        let hasConsentButtons = false;
        for (const button of buttons) {
          const buttonText = (button.textContent || '').toLowerCase();
          const buttonClasses = button.classList.toString().toLowerCase();
          if (buttonText.includes('accetta') || buttonText.includes('accept') || 
              buttonText.includes('rifiuta') || buttonText.includes('reject') ||
              buttonClasses.includes('accept') || buttonClasses.includes('reject')) {
            hasConsentButtons = true;
            break;
          }
        }
        if (hasConsentButtons) {
          return; // NON nascondere MAI il popup di consenso iniziale
        }

        // Controlla se contiene testo relativo alla privacy/consenso (barra bianca)
        const elementTextLower = (element.textContent || '').toLowerCase();
        const isPrivacyBar = elementTextLower.includes('informativa sulla raccolta') || 
                            elementTextLower.includes('preferenze relative alla privacy') ||
                            elementTextLower.includes('preferenze privacy') ||
                            elementTextLower.includes('cookie policy') ||
                            (elementTextLower.includes('privacy') && element.offsetHeight > 30);

        // Controlla anche se è posizionato in fondo alla pagina (fixed bottom)
        const style = window.getComputedStyle(element);
        const isFixedBottom = style.position === 'fixed' && (
          style.bottom === '0px' || 
          style.bottom === '0' ||
          parseInt(style.bottom) < 100
        );

        // Controlla se è una barra molto sottile (1-25px) in fondo - la fina riga bianca
        const isThinBar = element.offsetHeight > 0 && element.offsetHeight <= 25 && 
                         (isFixedBottom || parseInt(style.bottom) < 25);

        // Controlla se ha uno sfondo bianco o chiaro (tipico della barra bianca)
        const bgColor = style.backgroundColor;
        const isWhiteBar = bgColor && (
          bgColor.includes('rgb(255, 255, 255)') ||
          bgColor.includes('rgb(255,255,255)') ||
          bgColor === 'white' ||
          bgColor.includes('#fff') ||
          bgColor.includes('#ffffff')
        );

        // Controlla se è posizionato in fondo alla pagina (anche senza essere fixed)
        const rect = element.getBoundingClientRect();
        const hasIubendaClass = element.classList && Array.from(element.classList).some(cls => cls.includes('iubenda'));
        const isAtBottom = rect.bottom >= (window.innerHeight - 30) && rect.top < window.innerHeight;

        // Controlla se l'elemento è vuoto o ha solo spazi/bordi (barra decorativa)
        const elementTextTrimmed = (element.textContent || '').trim();
        const isEmptyOrMinimal = elementTextTrimmed.length === 0 || elementTextTrimmed.length < 10;

        // IMPORTANTE: Se è un elemento Iubenda in fondo alla pagina, nascondilo SEMPRE quando il consenso è dato
        // Questo cattura anche barre vuote o molto sottili senza testo
        // Se è un elemento Iubenda posizionato in fondo (anche senza essere fixed), nascondilo
        const isIubendaAtBottom = hasIubendaClass && isAtBottom;

        // Se è la barra bianca persistente (testo privacy O barra sottile con classi Iubenda O sfondo bianco con classi Iubenda O fixed bottom con classi Iubenda O elemento Iubenda vuoto in fondo), nascondila
        // IMPORTANTE: Nascondi SOLO se ha classi Iubenda o testo privacy - NON nascondere altri elementi bianchi dell'app
        // (questa funzione viene chiamata solo quando il consenso è stato dato)
        if (isPrivacyBar || 
            (isThinBar && hasIubendaClass) || 
            (isWhiteBar && hasIubendaClass) || 
            isIubendaAtBottom ||
            (isFixedBottom && hasIubendaClass && !element.classList.contains('iubenda-cs-preferences-link'))) {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.opacity = '0';
          element.style.height = '0';
          element.style.maxHeight = '0';
          element.style.overflow = 'hidden';
          element.style.margin = '0';
          element.style.padding = '0';
          element.style.border = 'none';
          element.style.position = 'fixed';
          element.style.bottom = '-9999px';
          element.style.zIndex = '-9999';
          element.classList.add('iubenda-banner-hidden');
        }
      });
    } catch (e) {
      console.debug('Iubenda banner manager: errore nel nascondere barra bianca', e);
    }
  };

  // Controlla se Iubenda è già caricato
  const checkIubenda = () => {
    // IMPORTANTE: Nascondi il banner SOLO se il consenso è stato dato
    const consentGiven = hasConsentGiven();
    
    // Controlla anche se Iubenda è caricato e ha informazioni sul consenso
    let iubendaConsentGiven = false;
    if (window._iub || window.iubenda) {
      try {
        // Iubenda potrebbe avere un metodo per controllare il consenso
        if (window._iub && typeof window._iub.getConsent === 'function') {
          const consent = window._iub.getConsent();
          if (consent && consent.given) {
            iubendaConsentGiven = true;
          }
        }
      } catch (e) {
        console.debug('Iubenda banner manager: errore nel controllo consenso Iubenda API', e);
      }
    }
    
    // Nascondi il banner SOLO se il consenso è stato dato (da cookie/localStorage O da API Iubenda)
    if (consentGiven || iubendaConsentGiven) {
      hideBanner();
    }
    // Se il consenso NON è stato dato, NON nascondere il banner - deve essere visibile!
  };

  // Esegui il controllo quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkIubenda);
  } else {
    checkIubenda();
  }

  // Esegui il controllo anche dopo un delay per assicurarsi che Iubenda sia caricato
  // IMPORTANTE: Non nascondere il banner se il consenso non è stato dato
  setTimeout(checkIubenda, 2000);
  setTimeout(checkIubenda, 4000);
  setTimeout(checkIubenda, 6000); // Controllo aggiuntivo per catturare elementi aggiunti dopo il login

  // IMPORTANTE: Ascolta i cambiamenti di route/navigazione (per SPA)
  // Quando la pagina cambia (dopo login), ricontrolla e nascondi la barra bianca se il consenso è dato
  if (window.history && window.history.pushState) {
    const originalPushState = window.history.pushState;
    window.history.pushState = function(...args) {
      originalPushState.apply(window.history, args);
      setTimeout(() => {
        if (hasConsentGiven()) {
          hideBanner();
        }
      }, 500);
    };
  }

  // Ascolta anche popstate per navigazione con back/forward
  window.addEventListener('popstate', () => {
    setTimeout(() => {
      if (hasConsentGiven()) {
        hideBanner();
      }
    }, 500);
  });

  // IMPORTANTE: Ascolta lo scroll per nascondere la barra bianca quando appare durante lo scroll
  // Questo è importante perché la barra potrebbe essere visibile solo quando si scrolla in fondo
  let scrollTimeout;
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    // Controlla solo quando si scrolla verso il basso o si è vicini al fondo
    if (currentScrollY >= lastScrollY || (window.innerHeight + currentScrollY) >= document.body.offsetHeight - 100) {
      // Debounce per non eseguire troppe volte
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (hasConsentGiven()) {
          hideBanner();
        }
      }, 50); // Controllo più frequente durante lo scroll
    }
    lastScrollY = currentScrollY;
  }, { passive: true });

  // Ascolta gli eventi di Iubenda per nascondere il banner quando il consenso viene dato
  if (window.addEventListener) {
    window.addEventListener('iubendaConsentGiven', () => {
      hideBanner();
    });
    
    // Ascolta anche eventi personalizzati che Iubenda potrebbe emettere
    window.addEventListener('consentGiven', () => {
      hideBanner();
    });
  }

  // IMPORTANTE: Assicura che l'icona persistente funzioni correttamente
  // Aggiungi listener per il click sull'icona per evitare che venga nascosta
  const protectIconAndPopup = () => {
    // Trova l'icona persistente
    const preferenceIcon = document.querySelector('.iubenda-cs-preferences-link, .iubenda-cs-close-btn');
    if (preferenceIcon) {
      // Assicura che l'icona sia sempre visibile
      preferenceIcon.style.display = 'block';
      preferenceIcon.style.visibility = 'visible';
      preferenceIcon.style.opacity = '1';
      preferenceIcon.style.zIndex = '999999';

      // Aggiungi listener per il click
      preferenceIcon.addEventListener('click', (e) => {
        // Quando l'icona viene cliccata, assicurati che il popup non venga nascosto
        setTimeout(() => {
          const popup = document.querySelector('.iubenda-cs-overlay, .iubenda-cs-modal, .iubenda-cs-popup');
          if (popup) {
            popup.style.display = 'block';
            popup.style.visibility = 'visible';
            popup.style.opacity = '1';
            popup.style.zIndex = '999998';
          }
          // Mantieni l'icona visibile
          preferenceIcon.style.display = 'block';
          preferenceIcon.style.visibility = 'visible';
          preferenceIcon.style.opacity = '1';
        }, 100);
      }, { passive: true });
    }
  };

  // Esegui la protezione dell'icona periodicamente
  setInterval(protectIconAndPopup, 1000);

  // Observer per nascondere il banner quando viene aggiunto al DOM
  // IMPORTANTE: Nasconde SOLO se il consenso è stato dato
  // IMPORTANTE: NON nascondere MAI il popup o l'icona persistente
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // IMPORTANTE: NON nascondere MAI il popup/modal che si apre quando clicchi sull'icona
          if (node.classList && (
            node.classList.contains('iubenda-cs-overlay') ||
            node.classList.contains('iubenda-cs-modal') ||
            node.classList.contains('iubenda-cs-popup') ||
            node.id && (node.id.includes('overlay') || node.id.includes('modal') || node.id.includes('popup'))
          )) {
            // Assicura che il popup sia sempre visibile quando viene aggiunto
            setTimeout(() => {
              if (node.style) {
                node.style.display = 'block';
                node.style.visibility = 'visible';
                node.style.opacity = '1';
                node.style.zIndex = '999998';
              }
            }, 10);
            return; // Non nascondere il popup delle preferenze
          }


          // IMPORTANTE: NON nascondere MAI il popup di consenso iniziale (quello con i pulsanti Accetta/Rifiuta)
          if (node.querySelector) {
            const buttons = node.querySelectorAll('button');
            let hasConsentButtons = false;
            for (const button of buttons) {
              const buttonText = (button.textContent || '').toLowerCase();
              const buttonClasses = button.classList.toString().toLowerCase();
              if (buttonText.includes('accetta') || buttonText.includes('accept') || 
                  buttonText.includes('rifiuta') || buttonText.includes('reject') ||
                  buttonClasses.includes('accept') || buttonClasses.includes('reject')) {
                hasConsentButtons = true;
                break;
              }
            }
            if (hasConsentButtons) {
              // Assicura che il popup di consenso iniziale sia sempre visibile
              setTimeout(() => {
                if (node.style) {
                  node.style.display = 'block';
                  node.style.visibility = 'visible';
                  node.style.opacity = '1';
                  node.style.zIndex = '999999';
                }
              }, 10);
              return; // Non nascondere il popup di consenso iniziale
            }
          }

          // IMPORTANTE: NON nascondere MAI l'icona persistente
          if (node.classList && (
            node.classList.contains('iubenda-cs-preferences-link') ||
            node.classList.contains('iubenda-cs-close-btn') ||
            node.id && (node.id.includes('preferences') || node.id.includes('close'))
          )) {
            // Assicura che l'icona sia sempre visibile
            setTimeout(() => {
              if (node.style) {
                node.style.display = 'block';
                node.style.visibility = 'visible';
                node.style.opacity = '1';
                node.style.zIndex = '999999';
              }
            }, 10);
            return; // Non nascondere l'icona persistente
          }

          if (node.classList && (
            node.classList.contains('iubenda-cs-banner') ||
            node.classList.contains('iubenda-cs-consent') ||
            (node.id && node.id.includes('iubenda') && !node.id.includes('preferences') && !node.id.includes('close') && !node.id.includes('overlay') && !node.id.includes('modal'))
          )) {
            // Aspetta che Iubenda finisca di caricare il banner, poi controlla il consenso
            // Se il consenso NON è stato dato, NON nascondere il banner
            setTimeout(() => {
              const consentGiven = hasConsentGiven();
              if (consentGiven) {
                // Solo se il consenso è stato dato, nascondi il banner
                hideBanner();
              }
              // Se il consenso NON è stato dato, lascia il banner visibile
            }, 500); // Delay più lungo per dare tempo a Iubenda di caricare
          }
        }
      });
    });
  });

  // Inizia a osservare i cambiamenti nel DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Funzione per nascondere il banner quando viene cliccato "Accetta"
  const hideOnAccept = () => {
    // Cerca i pulsanti di accettazione
    const acceptButtons = document.querySelectorAll(
      '[class*="iubenda"][class*="accept"], ' +
      '[class*="iubenda"][class*="consent"], ' +
      'button[class*="iubenda"], ' +
      'a[class*="iubenda"][class*="accept"]'
    );

    acceptButtons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(hideBanner, 500);
      }, { once: true });
    });
  };

  // Controlla periodicamente per nascondere il banner SOLO se il consenso è stato dato
  // IMPORTANTE: Non nascondere se il consenso non è stato dato
  // IMPORTANTE: Non nascondere il popup delle preferenze quando è aperto
  // IMPORTANTE: Non nascondere mai l'icona persistente
  setInterval(() => {
    // Controlla se il popup delle preferenze è aperto
    const isPopupOpen = document.querySelector('.iubenda-cs-overlay, .iubenda-cs-modal, .iubenda-cs-popup');
    if (isPopupOpen) {
      return; // Non nascondere nulla se il popup è aperto
    }

    // IMPORTANTE: Assicurati che l'icona persistente sia sempre visibile
    const preferenceIcon = document.querySelector('.iubenda-cs-preferences-link, .iubenda-cs-close-btn');
    if (preferenceIcon) {
      preferenceIcon.style.display = 'block';
      preferenceIcon.style.visibility = 'visible';
      preferenceIcon.style.opacity = '1';
    }

    const consentGiven = hasConsentGiven();
    if (consentGiven) {
      // Solo se il consenso è stato dato, nascondi il banner
      hideBanner();
    }
    // Cerca pulsanti di accettazione per nascondere il banner quando vengono cliccati
    hideOnAccept();
  }, 2000); // Controllo ogni 2 secondi per essere più reattivo dopo login/navigazione
}

// Esporta la funzione
export default hideIubendaBannerIfConsentGiven;
